class CartDrawer extends HTMLElement {
	constructor() {
		super()
		window.FoxTheme = window.FoxTheme || {}
		window.FoxTheme.Cart = this
		this.drawer = this.closest('drawer-component')
		window.FoxTheme.CartDrawer = this.drawer
        this.openWhenAdded = this.dataset.openWhenAdded === 'true'
        this.checkSamples()
	}

	connectedCallback() {
    window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, async state => {
      this.renderContents(state)
      if(typeof(window.checkCartForPanels)=='function') window.checkCartForPanels();
      if(typeof(window.pdpSampleAdded)=='function') window.pdpSampleAdded(state);
    })
    window.FoxThemeEvents.subscribe(`ON_CART_UPDATED`, async state => {
      this.checkSamples()
      if(typeof(window.checkCartForPanels)=='function') window.checkCartForPanels();
    })
  }

  checkSamples() {
    let samplesInCart = document.querySelectorAll('.f-cart-drawer__item.f-cart-item[data-cart-item-product-title~="Sample:"]');
    let cartSampleIds = [];
    const sampleLimit = 3;

    // PDP page
    let pdpSampleSelector = document.querySelector('#sample.sample-pdp')
    let pdpSecondSampleSelector = document.querySelector('#sample-trigger-button')
    if(pdpSampleSelector != null) {
      if(samplesInCart != null && samplesInCart.length > (sampleLimit - 1)) {
        // No more samples
        pdpSampleSelector.classList.add('samples-limit')
        pdpSecondSampleSelector.classList.add('samples-limit')
      }
      else {
        pdpSampleSelector.classList.remove('samples-limit')
        pdpSecondSampleSelector.classList.remove('samples-limit')
      }
    }

    // Sample selector
    const sampleSelectorCards = document.querySelectorAll('.sample-card');
    const sampleSelectorLimit = document.querySelector('.sample-page-limit');
    const sampleCardsTot = sampleSelectorCards.length;
    if(typeof checkCartUpdateSamples != 'undefined') {
      checkCartUpdateSamples();
    }

    // Already in the cart?
    let samplesToClear = document.querySelectorAll('.product-card__atc.disabled');
    for(let cs=0; cs<samplesToClear.length; cs++){
      samplesToClear[cs].removeAttribute('disabled','disabled');
      samplesToClear[cs].classList.remove('disabled');
    }

    // Disable button on sample selector
    for(let c=0; c<samplesInCart.length; c++){
      cartSampleIds.push(samplesInCart[c].dataset.cartItemProductId);
      let addToCartInput = document.querySelector('input[value="'+samplesInCart[c].dataset.cartItemProductId+'"]');
      if(addToCartInput) {
        let btn =  addToCartInput.parentElement.querySelector('.product-card__atc');
        if(btn) {
          btn.setAttribute('disabled','disabled');
          btn.classList.add('disabled');
        }
      }
    }

    if(samplesInCart != null && samplesInCart.length > (sampleLimit - 1)) {
      for(let s=0; s<sampleCardsTot; s++){
        sampleSelectorCards[s].classList.add('tot-reached');
      }
      if(sampleSelectorLimit) sampleSelectorLimit.classList.add('show');
    }
    else {
      for(let s=0; s<sampleCardsTot; s++){
        sampleSelectorCards[s].classList.remove('tot-reached');
      }
      if(sampleSelectorLimit) sampleSelectorLimit.classList.remove('show');
    }
  }
  
  renderContents(parsedState, renderFooter = true) {

    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (window.FoxKitV2 && window.FoxKitPlugins.InCart.length > 0 && window.FoxKitV2.Modules.InCart) {
      window.FoxKitV2.Modules.InCart.getCart()
    }

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen()) {
        this.drawer.openDrawer()
        document.body.classList.add('prevent-scroll')
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState)
      }
    });

    this.checkSamples()

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
    ]

    if (renderFooter) {
      sections.push({
        id: 'cart-drawer',
        selector: '.f-drawer__footer',
      })
    }

    return sections
  }

}
customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {

  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(document.querySelector('cart-drawer'), { overlay: document.querySelector('cart-drawer') })
  }
  getSectionsToRender() {
    return [
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__block-subtotal',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
